import { render, staticRenderFns } from "./BdssfReportTop.vue?vue&type=template&id=01627e32&scoped=true&"
import script from "./BdssfReportTop.vue?vue&type=script&lang=js&"
export * from "./BdssfReportTop.vue?vue&type=script&lang=js&"
import style0 from "./BdssfReportTop.vue?vue&type=style&index=0&id=01627e32&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01627e32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VContainer,VSlideXTransition,VTab,VTabs,VTabsSlider})
